export default "__VITE_ASSET__C$o_Hj2a__"